import { Stack, Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { AuthorEvaluationOverview } from '@/module/Evaluation/AuthorEvaluationOverview';
import { getEvaluationOptions } from '@/module/Evaluation/model/EvaluationQuery';

import { useCurrentUser } from '@feature/security';

export const Route = createFileRoute('/_auth/evaluation/_layout/$evaluationId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
  loader: async ({ params: { evaluationId }, context: { queryClient } }) => {
    return await queryClient.ensureQueryData(getEvaluationOptions(evaluationId));
  },
});

function RouteComponent() {
  const { evaluationId } = Route.useParams();
  const { data: evaluation } = useSuspenseQuery(getEvaluationOptions(evaluationId));
  const userId = Route.useSearch().userId;
  const { currentRole } = useCurrentUser();

  return (
    <Stack>
      {userId != null && (
        <AuthorEvaluationOverview
          evaluation={evaluation}
          userId={userId}
          canDownloadUnsignedReport={currentRole === 'DEPARTMENT_ADMIN' || currentRole === 'UNIVERSITY_ADMIN'}
          canVerifyEvaluation={currentRole != 'AUTHOR'}
          canStartEvaluation={currentRole == 'AUTHOR'}
          currentRole={currentRole}
        />
      )}
      {userId == null && <Text>Utilizator neselectat</Text>}
    </Stack>
  );
}
